import { v4 as uuid } from 'uuid';
import { ReferenceAnswerValue } from '../../types';
import { breadcrumbsToNamePath } from '../../utils/stringUtils';
import { ComponentOption } from '../QuestionOptions/questionOptionsTypes';

export const createReferenceFromOption = (
  refOption: ComponentOption,
  outgoing?: boolean
): ReferenceAnswerValue => {
  return {
    outgoing,
    tempId: uuid(),
    component: createComponentForReferenceAnswer(refOption),
    answers: {},
  };
};

export const createComponentForReferenceAnswer = (
  refOption: ComponentOption
) => {
  const isNew = refOption.value === refOption.label;

  return {
    _id: isNew ? undefined : `${refOption.value}`,
    name: refOption.label,
    identifierString: refOption.identifierString
      ? refOption.identifierString
      : undefined,
    namePath: refOption.breadcrumbs
      ? breadcrumbsToNamePath(refOption.breadcrumbs)
      : [refOption.label],
  };
};
